// Locales
import 'angular-i18n/angular-locale_en.js'
import 'angular-i18n/angular-locale_en-gb.js'
import 'angular-i18n/angular-locale_it.js'
import 'angular-i18n/angular-locale_fr'
import 'angular-i18n/angular-locale_ja'

/**
 * Languages that are made available to the translation provider in {@link tmrTranslationConfig}
 *
 * If `default` key is present, that language will become default
 * If not, `languages` will be used to determine automatically the
 * preferred user's language from the browser
 *
 * @namespace tmrLanguages
 * @type {ngConstant}
 * @see https://angular-translate.github.io/docs/#/guide/09_language-negotiation
 * @see about the prefix option {@link https://angular-translate.github.io/docs/#/guide/12_asynchronous-loading}
 */
export const constant = [
  'tmrLanguages',
  {
    default: 'en',
    languages: {
      en: {
        label: 'English',
        alias: 'en-*',
      },
      'en-gb': {
        label: 'English (Great Britain)',
      },
      it: {
        label: 'Italiano',
        alias: 'it-*',
      },
      fr: {
        label: 'Française',
        alias: 'fr-*',
      },
      ja: {
        label: '日本語',
        alias: 'ja-*',
      },
    },
  },
]
